import invoice from '@/locales/en/invoice/invoice.locales';

export default {
    ...invoice,
};
